"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var LoadingWrapper = exports.LoadingWrapper = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: ", ";\n  min-width: ", ";\n  height: ", ";\n  border-radius: var(--border-radius-sm);\n  overflow: hidden;\n  border: var(--border-width-hairline) solid var(--color-neutral-100);\n  border-radius: ", ";\n"])), function (_ref) {
  var imageSize = _ref.imageSize;
  return imageSize === 'large' ? '72px' : '44px';
}, function (_ref2) {
  var imageSize = _ref2.imageSize;
  return imageSize === 'large' ? '72px' : '44px';
}, function (_ref3) {
  var imageSize = _ref3.imageSize;
  return imageSize === 'large' ? '72px' : '44px';
}, function (_ref4) {
  var imageSize = _ref4.imageSize;
  return imageSize === 'large' ? 'var(--border-radius-md)' : 'var(--border-radius-sm)';
});